import './App.css';
import React, { useRef, useEffect, useState } from 'react'
import RetroConsole from './console/retroConsole'
import ConsoleTextArea from './console/consoleTextArea';


function App() {
  const containerRef = useRef();
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      setScale(
        Math.min(
          containerRef.current.offsetWidth / 800,
          containerRef.current.offsetHeight / 600
        ))
    });
    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);

  return (
    <div id="main-container" ref={containerRef}>
      <RetroConsole scale={scale}>
        <ConsoleTextArea />
      </RetroConsole>
    </div>
  );
}

export default App;
